import { render, staticRenderFns } from "./appointmentxyIndex.vue?vue&type=template&id=3fd6a20a&scoped=true&"
import script from "./appointmentxyIndex.vue?vue&type=script&lang=js&"
export * from "./appointmentxyIndex.vue?vue&type=script&lang=js&"
import style0 from "./appointmentxyIndex.vue?vue&type=style&index=0&id=3fd6a20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd6a20a",
  null
  
)

export default component.exports